export interface QRTemplateResponse {
    template_url: string,
    position_url: string
}

export enum TabTypes {
    markerOperations = 'Marker Operations',
    qrGeneration = 'Qr Generation',
    userManagement = 'User Management',
}
